export class BackNumberConfig {
    id: number;
    rodeoId: number;
    eventType: string;
    startNumber: number;
    byHorse: boolean;

    constructor() {
        this.startNumber = 1;
        this.byHorse = true;
    }
}


// WEBPACK FOOTER //
// ./src/model/back-number-config.ts